import { render, staticRenderFns } from "./KuaishouTargetingAdd.vue?vue&type=template&id=4953ec7e&scoped=true"
import script from "./KuaishouTargetingAdd.vue?vue&type=script&lang=js"
export * from "./KuaishouTargetingAdd.vue?vue&type=script&lang=js"
import style0 from "./KuaishouTargetingAdd.vue?vue&type=style&index=0&id=4953ec7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4953ec7e",
  null
  
)

export default component.exports